export const shortenText = (text?: string, length?: number) => {
  // Проверяем входные данные
  if (!text || !length || length <= 0) return ''

  // Если текст короче или равен длине - возвращаем как есть
  if (text.length <= length) return text

  // Обрезаем с запасом для многоточия
  const maxLength = Math.max(1, length - 3) // Оставляем место для "..."
  let trimmed = text.slice(0, maxLength)

  // Убираем возможную пунктуацию в конце
  const lastChar = trimmed[trimmed.length - 1]
  if (/[.,;:!?]/.test(lastChar)) {
    trimmed = trimmed.slice(0, -1)
  }

  // Убираем возможные пробелы в конце
  trimmed = trimmed.trimEnd()

  // Если после всех манипуляций строка пустая
  if (!trimmed) return '...'

  return `${trimmed}...`
}
